import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { StandardURL } from "../App";

const WaterUnitsPage = () => {
  const [waterUnits, setWaterUnits] = useState({
    units: null,
    amount: null,
    water_unit_id: null,
  }); // State for water units as an object
  // State for water units
  const [showAddModal, setShowAddModal] = useState(false); // State for showing add modal
  const [units, setUnits] = useState(null); // State for units
  const [amount, setAmount] = useState(null); // State for amount
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const propertyId = localStorage.getItem("selectedPropertyId");

    axios
      .get(
        `${StandardURL}/iNyumba/waterunits/fetchonewaterunit/${propertyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        const waterUnitsData = response.data.response;

        if (waterUnitsData.length > 0) {
          const { units, amount, water_unit_id } = waterUnitsData[0];
          setWaterUnits({ units, amount, water_unit_id });
        }
      })
      .catch((error) => {
        console.error("Error fetching water units:", error);
      });
  }, []);

  const handleAddWaterUnits = () => {
    // Create FormData object
    const formData = new FormData();
    formData.append("units", units);
    formData.append("amount", amount);

    const propertyId = localStorage.getItem("selectedPropertyId");
    const token = localStorage.getItem("token");

    // Send POST request to add water units
    axios
      .post(
        `${StandardURL}/iNyumba/waterunits/postwaterunits/${propertyId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response);
        setShowAddModal(false); // Close the modal after adding water units
      })
      .catch((error) => {
        toast.error(error.response.data.response);
        console.error("Error adding water units:", error);
      });
  };

  const handleUpdateWaterUnits = () => {
    localStorage.setItem("waterUnits", JSON.stringify(waterUnits));
    navigate("/landlord/updatewaterunits");
  };

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
          <div className="max-w-xl w-full bg-white p-8 rounded-xl shadow-2xl border border-gray-200">
            <h1 className="text-4xl font-extrabold text-gray-900 mb-6 text-center">
              Water Units 💧
            </h1>
            <hr className="my-6 border-gray-200" />

            {/* Display water units */}
            <div className="mb-8 p-6 bg-blue-50 rounded-lg shadow-inner border border-blue-200">
              <h2 className="text-2xl font-bold text-blue-800 mb-4">Current Status</h2>
              <p className="text-lg text-gray-700 mb-2">
                <strong className="font-semibold text-gray-800">Current Water Units:</strong>{" "}
                {waterUnits.units !== null ? waterUnits.units : "N/A"}
              </p>
              <p className="text-lg text-gray-700">
                <strong className="font-semibold text-gray-800">Current Water Amount:</strong>{" "}
                {waterUnits.amount !== null ? `Ksh ${waterUnits.amount.toLocaleString()}` : "N/A"}
              </p>
            </div>

            {/* Conditionally render the buttons */}
            <div className="flex flex-wrap justify-center gap-4 mt-6">
              {waterUnits.units !== null ? ( // Changed condition to check for null
                <>
                  {/* Only show the Update Water Units button when units exist */}
                  <button
                    onClick={handleUpdateWaterUnits}
                    className="flex items-center px-6 py-3 bg-green-600 text-white font-semibold rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition duration-300 ease-in-out"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                      <path
                        fillRule="evenodd"
                        d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Update Water Units
                  </button>
                </>
              ) : (
                <>
                  {/* Show Add Water Units button if units are not present */}
                  <button
                    onClick={() => setShowAddModal(true)}
                    className="flex items-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-2"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Add Water Units
                  </button>
                </>
              )}

              <button
                onClick={handleBack}
                className="flex items-center px-6 py-3 bg-gray-500 text-white font-semibold rounded-lg shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition duration-300 ease-in-out"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Back
              </button>
            </div>

            {/* Modal for adding water units */}
            <Modal
              isOpen={showAddModal}
              onRequestClose={() => setShowAddModal(false)}
              className="fixed inset-0 flex items-center justify-center p-4 z-50"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
            >
              <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md mx-auto">
                <h2 className="text-2xl font-semibold text-gray-900 mb-6 text-center">Add Water Units 📝</h2>
                <p className="text-gray-600 text-sm mb-6 p-3 bg-yellow-50 rounded-md border border-yellow-200">
                  <strong className="font-bold">Heads Up:</strong> If you already have water units, consider updating them instead of adding a new one to avoid conflicts.
                </p>
                <div className="mb-4">
                  <label htmlFor="units" className="block text-sm font-medium text-gray-700 mb-2">
                    Units:
                  </label>
                  <input
                    type="number"
                    id="units"
                    className="w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
                    value={units}
                    onChange={(e) => setUnits(e.target.value)}
                    placeholder="Enter water units"
                  />
                </div>
                <div className="mb-6">
                  <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-2">
                    Amount:
                  </label>
                  <input
                    type="number"
                    id="amount"
                    className="w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Enter amount"
                  />
                </div>
                <div className="flex justify-end gap-3">
                  <button
                    onClick={handleAddWaterUnits}
                    className="flex-1 sm:flex-none px-5 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300"
                  >
                    Add
                  </button>
                  <button
                    onClick={() => setShowAddModal(false)}
                    className="flex-1 sm:flex-none px-5 py-2 bg-gray-300 text-gray-800 font-semibold rounded-md shadow-sm hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition duration-300"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </AuthGuard>
    </RoleGuard>
  );
};

export default WaterUnitsPage;
